<template>
    <div class="columns is-mobile is-centered has-background-primary p-2"  v-if="props.titoloVisibile==true">
        <h1 class="title is-4 has-text-white"> MATERIALI E MANODOPERA</h1>
    </div>

    <div class="box" @submit.prevent="" v-if="formAttivo">

        <div class="columns">
            <div class="column">
                <div class="field buttons">
                    <button class="button is-light" @click="bChiudi">Chiudi</button>
                    <button class="button is-primary" @click="bSalva" :disabled="!elementoDaAggiornare">Salva</button>
                </div>
            </div>
            <div class="column is-1" v-if="props.idCosto==-1">
                <div class="control">
                    <button class="button is-primary is-outlined" :disabled="!copiaTrasporto.costo" @click="bIncolla">
                        <span class="icon"><i class="fas fa-paste"></i></span>
                    </button>
                </div>
            </div>
            <div class="column" v-if="props.vista=='indipendente'">
                <p>
                    <a @click="gestisciSelezioneElemento({tipo: 'cliente', idCliente: leggiInfoDBRaw(elementoSelezionato)?.idCliente || props.idCliente})" title="Vai al cliente">
                        <i class="fas fa-user"></i> &nbsp; {{ generaStringaCliente(leggiInfoDBRaw(elementoSelezionato)?.idCliente || props.idCliente) }}
                    </a>
                </p>
            </div>
            <div class="column" v-if="props.vista=='indipendente'">
                <p>
                    <a @click="gestisciSelezioneElemento({tipo: 'lavoro', idCliente: leggiInfoDBRaw(elementoSelezionato)?.idCliente || props.idCliente, idLavoro: leggiInfoDBRaw(elementoSelezionato)?.idLavoro || props.idLavoro})" title="Vai al lavoro">
                        <i class="fas fa-arrow-right-from-bracket"></i> &nbsp; {{ generaStringaCliente(leggiInfoDBRaw(elementoSelezionato)?.idCliente || props.idCliente, leggiInfoDBRaw(elementoSelezionato)?.idLavoro || props.idLavoro, 'lavoroCorta') }}
                    </a>
                </p>
            </div>
            <div class="column">
                <div class="field buttons is-right">
                    <button class="button is-danger" @click="bElimina" v-if="props.idCosto!=-1">Elimina</button>
                </div>
            </div>
        </div>

        <div class="columns">
            <div class="column is-3">
                <CampoData @valoreCambiato="elementoModifica"
                    :valore=elementoSelezionato.data
                    identificativo="data"
                    etichetta="Data"/>
            </div>
            <div class="column is-7" v-if="titoloVisibile">
                <label class="label">Lavoro</label>
                <div class="field has-addons">
                    <div class="control is-expanded">
                        <input class="input" disabled="true" type="text" :value="generaStringaCliente(leggiInfoDBRaw(elementoSelezionato)?.idCliente || props.idCliente, leggiInfoDBRaw(elementoSelezionato)?.idLavoro || props.idLavoro, 'lavoro')">
                    </div>
                    <div class="control">
                        <button class="button is-primary" @click="bSelezionaLavoro">
                            &ensp;<i class="fas fa-arrow-right-from-bracket"></i>&ensp;
                        </button>
                    </div>
                </div>
            </div>
            <div class="column is-2">
                <CampoTendina @valoreCambiato="(valore)=>elementoModifica(valore, 'tipoCosto')"
                    :valore=tipoCosto
                    idTendina="tipoCosto"
                    etichetta="Tipo"/>
            </div>
        </div>
        <div class="columns">
            <div class="column is-3" v-if="tipoCosto=='lavoro'">
                <CampoTendina @valoreCambiato="(valore)=>elementoModifica(valore, 'lavoratore')"
                    :valore=elementoSelezionato.lavoratore
                    idTendina="lavoratore"
                    etichetta="Lavoratore"/>
            </div>
            <div class="column is-2" v-if="tipoCosto=='costo'">
                <div class="field">
                    <label class="label">Fornitore</label>
                    <div class="control">
                        <input class="input" type="text" v-model="elementoSelezionato.fornitore"  @change="elementoModifica(elementoSelezionato.fornitore, 'fornitore')">
                    </div>
                </div>
            </div>
            <div class="column is-2" v-if="tipoCosto=='costo'">
                <div class="field">
                    <label class="label">Documento</label>
                    <div class="control">
                        <input class="input" type="text" v-model="elementoSelezionato.documento"  @change="elementoModifica(elementoSelezionato.documento, 'documento')">
                    </div>
                </div>
            </div>
            <div class="column is-4" v-if="tipoCosto=='lavoro'||tipoCosto=='costo'">
                <div class="field">
                    <label class="label">Descrizione</label>
                    <div class="control">
                        <input class="input" type="text" v-model="elementoSelezionato.descrizione"  @change="elementoModifica(elementoSelezionato.descrizione, 'descrizione')">
                    </div>
                </div>
            </div>
            <div class="column is-2" v-if="tipoCosto=='lavoro'">
                <CampoNumero @valoreCambiato="elementoModifica"
                    :valore=elementoSelezionato.ore
                    identificativo="ore"
                    etichetta="Ore"
                    tipo="Intero"/>
            </div>
            <div class="column is-2" v-if="tipoCosto=='costo'">
                <CampoNumero @valoreCambiato="elementoModifica"
                    @bottoneClick="bCambiaAliquota"
                    :valore=elementoSelezionato.costo
                    identificativo="costo"
                    etichetta="Costo"
                    tipoBottone="aliquota"
                    :decimali="2"
                    tipo="Decimale"/>
            </div>
            <div class="column is-1" v-if="tipoCosto=='lavoro'||tipoCosto=='costo'">
                <CampoCheckbox @valoreCambiato="elementoModifica"
                    :valore=elementoSelezionato.extra
                    identificativo="extra"
                    etichetta="Extra"/>
            </div>
            <div class="column is-1" v-if="tipoCosto=='lavoro'||tipoCosto=='costo'">
                <CampoCheckbox @valoreCambiato="elementoModifica"
                    :valore=elementoSelezionato.garanzia
                    identificativo="garanzia"
                    etichetta="Garanzia"/>
            </div>
        </div>
        <div class="columns">
            <div class="column is-12">
                <div class="field">
                    <label class="label">Note</label>
                    <div class="control">
                        <textarea class="textarea" placeholder="Note"  rows="2" v-model="elementoSelezionato.note"  @change="elementoModifica(elementoSelezionato.note, 'note')"></textarea>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <MessaggioModale @selezionato="bComandoModale"
        :confMessaggioModale=messaggioModale
        v-if="messaggioModale"/>

    <MessaggioModaleSconti @selezionato="bComandoModale"
        :confMessaggioModale=messaggioModaleSconti
        v-if="messaggioModaleSconti"/>

    <ElencoLavoriModale
        :bottoneAggiungiVisibile=false
        :campoRicercaVisibile=true
        @elementoSelezionato="bCambiaLavoroDaModale"
        v-if="mostraElencoLavoriModale"/>

</template>

<script setup>
    import CampoNumero from "./CampoNumero.vue";
    import CampoTendina from "./CampoTendina.vue";
    import CampoData from "./CampoData.vue";
    import CampoCheckbox from "./CampoCheckbox.vue";
    import MessaggioModale from "./MessaggioModale.vue";
    import MessaggioModaleSconti from "./MessaggioModaleSconti.vue";
    import ElencoLavoriModale from "./ElencoLavoriModale.vue";
    // FIX: Aggiunto watch
    import { defineProps, defineEmits, ref, nextTick, watch } from "vue";
    import { dbClienti, salvaCostoInFirestore, eliminaCostoInFirestore, leggiInfoDBRaw, aggiungiInfoDB} from "./../code/gestioneDB";
    import { generaIdCosto, copiaTrasporto, generaStringaCliente, clonaOggetto } from "./../code/utilita";

    // PROPRIETA' ED EVENTI DEL COMPONENTE
    const props = defineProps({
        idCosto: {
            type: Number,
            default: -1
        },
        idLavoro: {
            type: Number,
            default: null
        },
        idCliente: {
            type: Number,
            default: null
        },
        titoloVisibile: {
            type: Boolean,
            default: true
        },
        vista: {                    // indipendente, subordinata
            type: String,
            default: 'indipendente'
        }
    });
    const emit = defineEmits(['elementoSelezionato', 'modificaElementoInCorso']);

    // VARIABILI DEL COMPONENTE
    // FIX: Inizializzato a {} per sicurezza form
    const elementoSelezionato = ref({});              
    const elementoDaAggiornare = ref(null);             
    const messaggioModale = ref(null);              
    const messaggioModaleSconti = ref(null);        
    const mostraElencoLavoriModale = ref(false);    
    const idElementoSelezionato = ref(props.idCosto);
    const formAttivo = ref(true);                   
    const tipoCosto = ref(null);                    

    // FIX: Watcher di sicurezza
    watch(() => props.idCosto, (nuovoId) => {
        idElementoSelezionato.value = nuovoId || -1;
        setupForm();
    });

    // SETUP DEL COMPONENTE
    setupForm();

    // FUNZIONI DEL COMPONENTE
    function setupForm() {
        const id = idElementoSelezionato.value;

        // FIX: Scheletro di Base 
        const scheletroBase = {
            data: null,
            tipoCosto: null,
            lavoratore: null,
            fornitore: null,
            documento: null,
            descrizione: null,
            ore: null,
            costo: null,
            extra: false,
            garanzia: false,
            note: null
        };

        if ( id == -1 ) {
            elementoSelezionato.value = { ...scheletroBase };
            aggiungiInfoDB(elementoSelezionato.value, {
                id: -1,
                idCliente: props.idCliente,
                idLavoro: props.idLavoro
            });
        } else {
            // FIX: Estrazione protetta
            const clienteOriginale = dbClienti.value[props.idCliente];
            const lavoroOriginale = (clienteOriginale && clienteOriginale.lavori) ? clienteOriginale.lavori[props.idLavoro] : null;
            const costoOriginale = (lavoroOriginale && lavoroOriginale.costi) ? lavoroOriginale.costi[id] : null;

            if (costoOriginale) {
                elementoSelezionato.value = { ...scheletroBase, ...clonaOggetto(costoOriginale) };
                
                // Ricostruisce il DNA
                const infoRaw = leggiInfoDBRaw(costoOriginale) || { id: id, idCliente: props.idCliente, idLavoro: props.idLavoro };
                aggiungiInfoDB(elementoSelezionato.value, infoRaw);
            } else {
                elementoSelezionato.value = { ...scheletroBase };
                aggiungiInfoDB(elementoSelezionato.value, { id: id, idCliente: props.idCliente, idLavoro: props.idLavoro });
            }
        }
        elementoDaAggiornare.value = null;
        tipoCosto.value = (elementoSelezionato.value.lavoratore ? 'lavoro' : (elementoSelezionato.value.fornitore ? 'costo' : null));
    }

    function elementoModifica(valore, etichetta) {
        if (elementoDaAggiornare.value == null) {
            elementoDaAggiornare.value = {};
            aggiungiInfoDB(elementoDaAggiornare.value,
                leggiInfoDBRaw(elementoSelezionato.value)
            );
            emit('modificaElementoInCorso', true);
        }

        if (etichetta == 'tipoCosto') {
            tipoCosto.value = valore;
            elementoDaAggiornare.value.fornitore = null;
            elementoDaAggiornare.value.costo = null;
            elementoDaAggiornare.value.lavoratore = null;
            elementoDaAggiornare.value.ore = null;
            elementoSelezionato.value.fornitore = null;
            elementoSelezionato.value.costo = null;
            elementoSelezionato.value.lavoratore = null;
            elementoSelezionato.value.ore = null;
        } else {
            elementoDaAggiornare.value[etichetta] = valore;
            elementoSelezionato.value[etichetta] = valore;
        }
    }

    function bChiudi() {
        if (elementoDaAggiornare.value != null) {
            messaggioModale.value = {
                testoLight:{testo:'Annulla', comando:'annulla'},
                testoPrimary:null,
                testoDanger:{testo:'Chiudi senza salvare le modifiche', comando:'chiudi'},
                messaggio:"Proseguendo perderai le modifiche fatte"
            };
        } else {
            emit('elementoSelezionato', {
                tipo: 'costi'
            });
        }
    }

    function bSalva() {
        if ( (tipoCosto.value == 'costo' && !elementoSelezionato.value.fornitore) ) {
            messaggioModale.value = {
                testoLight:{testo:'Ok', comando:'annulla'},
                testoPrimary:null,
                testoDanger:null,
                messaggio:"Per salvare la voce di costo devi inserire un fornitore."
            };
            return;
        }
        if ( (tipoCosto.value == 'lavoro' && !elementoSelezionato.value.lavoratore) ) {
            messaggioModale.value = {
                testoLight:{testo:'Ok', comando:'annulla'},
                testoPrimary:null,
                testoDanger:null,
                messaggio:"Per salvare un lavoro devi inserire un lavoratore."
            };
            return;
        }

        messaggioModale.value = {
            testoLight:{testo:'Annulla', comando:'annulla'},
            testoPrimary:{testo:'Salva', comando:'salva'},
            testoDanger:null,
            messaggio:"Vuoi salvare le modifiche alla voce di costo?"
        };
    }

    function bElimina() {
        messaggioModale.value = {
            testoLight:{testo:'Annulla', comando:'annulla'},
            testoPrimary:null,
            testoDanger:{testo:'Elimina', comando:'elimina'},
            messaggio:"Vuoi eliminare la voce di costo?"
        };
    }

    async function bComandoModale(comando, valore) {
        // FIX: Scope isolati con { }
        switch (comando) {
            case 'annulla': {
                messaggioModale.value = null;
                messaggioModaleSconti.value = null;
                break;
            }
            case 'cancella': {
                emit('modificaElementoInCorso', false);
                messaggioModale.value = null;
                setupForm();
                resetForm();
                break;
            }
            case 'chiudi': {
                emit('modificaElementoInCorso', false);
                emit('elementoSelezionato', {
                        tipo: 'costi'
                    });
                messaggioModale.value = null;
                break;
            }
            case 'salva': {
                const tpIdCliente = leggiInfoDBRaw(elementoDaAggiornare.value)?.idCliente || props.idCliente;
                const tpIdLavoro = leggiInfoDBRaw(elementoDaAggiornare.value)?.idLavoro || props.idLavoro;

                if (!tpIdLavoro) {
                    messaggioModale.value = {
                        testoLight:{testo:'Ok', comando:'annulla'},
                        testoPrimary:null,
                        testoDanger:null,
                        messaggio:"Per salvare la voce di costo devi selezionare un lavoro."
                    };
                    return;
                }

                if (props.idLavoro && ( props.idLavoro != tpIdLavoro ) ) {
                    idElementoSelezionato.value = generaIdCosto(tpIdCliente, tpIdLavoro);
                    aggiungiInfoDB(elementoDaAggiornare.value, {
                        id: idElementoSelezionato.value,
                        idCliente: tpIdCliente,
                        idLavoro: tpIdLavoro
                    });
                    await salvaCostoInFirestore(elementoDaAggiornare.value, {
                        idCliente: props.idCliente,
                        idLavoro: props.idLavoro,
                        idCosto: props.idCosto
                    });
                } else {
                    if (idElementoSelezionato.value == -1) {
                        idElementoSelezionato.value = generaIdCosto(tpIdCliente, tpIdLavoro);
                    }
                    aggiungiInfoDB(elementoDaAggiornare.value, {
                        id: idElementoSelezionato.value,
                        idCliente: tpIdCliente,
                        idLavoro: tpIdLavoro
                    });
                    await salvaCostoInFirestore(elementoDaAggiornare.value);
                }
                
                messaggioModale.value = null;
                emit('modificaElementoInCorso', false);
                emit('elementoSelezionato', {
                    tipo: 'costo',
                    idCliente: parseInt(tpIdCliente),
                    idLavoro: parseInt(tpIdLavoro),
                    idCosto: idElementoSelezionato.value
                });
                break;
            }
            case 'elimina': {
                const tpIdCliente = leggiInfoDBRaw(elementoSelezionato.value)?.idCliente || props.idCliente;
                const tpIdLavoro = leggiInfoDBRaw(elementoSelezionato.value)?.idLavoro || props.idLavoro;
                
                eliminaCostoInFirestore(tpIdCliente, tpIdLavoro, idElementoSelezionato.value);
                emit('modificaElementoInCorso', false);
                emit('elementoSelezionato', {
                    tipo: 'costi'
                });
                break;
            }
            case 'applicaSconto': {
                if (elementoDaAggiornare.value == null) {
                    elementoDaAggiornare.value = {};
                }
                elementoDaAggiornare.value.costo = parseFloat(valore);
                elementoSelezionato.value.costo = parseFloat(valore);
                messaggioModaleSconti.value = null;
                resetForm();
                break;
            }
        }
    }

    function gestisciSelezioneElemento(elSelezionato) {
        if (elementoDaAggiornare.value != null) {
            messaggioModale.value = {
                testoLight:{testo:'Ok', comando:'annulla'},
                testoPrimary:null,
                testoDanger:null,
                messaggio:"Prima di uscire devi salvare o annullare le modifiche."
            };
        } else {
            emit('elementoSelezionato', elSelezionato);
        }
    }

    async function resetForm() {
        formAttivo.value = false;
        await nextTick();
        formAttivo.value = true;
    }

    function bIncolla() {
        if (elementoDaAggiornare.value==null) {
            emit('modificaElementoInCorso', false);
        }
        elementoSelezionato.value = {};
        elementoDaAggiornare.value = {};
        idElementoSelezionato.value = -1;
        elementoSelezionato.value = clonaOggetto(copiaTrasporto.value.costo);
        elementoDaAggiornare.value = clonaOggetto(copiaTrasporto.value.costo);
        aggiungiInfoDB(elementoSelezionato.value, leggiInfoDBRaw(copiaTrasporto.value.costo));
        aggiungiInfoDB(elementoDaAggiornare.value, leggiInfoDBRaw(copiaTrasporto.value.costo));
        if (props.idLavoro) {
            aggiornaLavoro(props.idCliente, props.idLavoro);
        }
        tipoCosto.value = (elementoSelezionato.value.lavoratore ? 'lavoro' : (elementoSelezionato.value.fornitore ? 'costo' : null));
        resetForm();
    }

    function bSelezionaLavoro() {
        mostraElencoLavoriModale.value = true;
    }

    function aggiornaLavoro(idCliente,idLavoro) {
        // FIX: Rimosso l'uso di stringaCliente/Lavoro a favore dell'iniezione dei soli ID
        const infoS = leggiInfoDBRaw(elementoSelezionato.value) || {};
        aggiungiInfoDB(elementoSelezionato.value, {
            ...infoS,
            idCliente: idCliente,
            idLavoro: idLavoro
        });
        
        if (elementoDaAggiornare.value) {
            const infoD = leggiInfoDBRaw(elementoDaAggiornare.value) || {};
            aggiungiInfoDB(elementoDaAggiornare.value, {
                ...infoD,
                idCliente: idCliente,
                idLavoro: idLavoro
            });
        }
    }

    function bCambiaLavoroDaModale(tempElemento) {
        if (tempElemento.idLavoro!=null) {
            if (elementoDaAggiornare.value == null) {
                elementoDaAggiornare.value = clonaOggetto(elementoSelezionato.value);
                idElementoSelezionato.value = -1;
                emit('modificaElementoInCorso', true);
            }
            aggiornaLavoro(tempElemento.idCliente, tempElemento.idLavoro);
            idElementoSelezionato.value = -1;
        }
        mostraElencoLavoriModale.value = false;
    }

    function bCambiaAliquota() {
        messaggioModaleSconti.value = {
            numeroDaModificare: elementoSelezionato.value.costo
        }
    }

</script>